import { Component } from '@verndale/core';
import addFormLabelsPlaceholder from '../helpers/addFormLabelsPlaceholder';
import { breakpoints } from '../helpers/variables';

class Footer extends Component {
  setupDefaults() {
    this.dom = {
      toggles: this.el.querySelectorAll(
        '.footer__menu-category .footer__menu-label'
      )
    };

    this.breakpoint = window.matchMedia(
      `(max-width: ${breakpoints.desktop - 1}px)`
    );
    addFormLabelsPlaceholder(this.el);
  }

  addListeners() {
    this.dom.toggles.forEach(toggle =>
      toggle.addEventListener('click', this.toggleSubmenu.bind(this))
    );
  }

  toggleSubmenu(e) {
    if (this.breakpoint.matches) {
      e.preventDefault();

      const { parentNode } = e.currentTarget;
      const subcategory = parentNode.querySelector('.footer__menu-subcategory');
      const inner = subcategory.querySelector('.footer__menu-subcategory ul');

      if (parentNode.classList.contains('footer__menu-category--expanded')) {
        subcategory.style.height = null;
        parentNode.classList.remove('footer__menu-category--expanded');
      } else {
        subcategory.style.height = `${inner.offsetHeight}px`;
        parentNode.classList.add('footer__menu-category--expanded');
      }
    }
  }
}

export default Footer;
